/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditBatchRequest extends models.ObjectIdBatchRequest {
    getFixupPrototypeFunction() { return RequestAuditBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditBatchRequest>): RequestAuditBatchRequest {
        let obj = Object.assign(new RequestAuditBatchRequest(), model);
        RequestAuditBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditBatchRequest>): RequestAuditBatchRequest {
        if (!model) return null;
        return RequestAuditBatchRequest.newInstance(<RequestAuditBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditBatchRequest) {
        if (!obj) return;

        models.RequestAuditBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditBatchRequest): boolean {
        if (models.ObjectIdBatchRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RequestAuditBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Include payload details if true
     */
    include_profile: boolean;

}
